import { createReducer, on } from '@ngrx/store';
import * as UserUpdateActions from '../actions/user-update.actions';
import {UpdateUserResponse} from '../../../services/api/users/user.model';

export const userUpdateFeatureKey = 'userUpdate';

export interface State {
  record: UpdateUserResponse | null;
  error: unknown | null;
  loaded: boolean;
  loading: boolean;
}

export const initialState: State = {
  record: null,
  error: null,
  loaded: false,
  loading: false,
};


export const reducer = createReducer(
  initialState,

  on(UserUpdateActions.userUpdate, () => ({
    record: null,
    error: null,
    loaded: false,
    loading: true,
  })),
  on(UserUpdateActions.userUpdateSuccess, (_state: State, action: {data: UpdateUserResponse}) => ({
    record: action.data,
    error: null,
    loaded: true,
    loading: false,
  })),
  on(UserUpdateActions.userUpdateFailure, (_state: State, action: {error: unknown}) => ({
    record: null,
    error: action.error,
    loaded: false,
    loading: false,
  })),
  on(UserUpdateActions.clearUserUpdateState, () => ({
    record: null,
    error: null,
    loaded: false,
    loading: false,
  })),
);
